import React from "react";
import { useDropzone } from 'react-dropzone';
import './Workflow.css'
import uploadImg from "./../../static/cloud-upload-regular-240.png";
import { TbFileUpload } from "react-icons/tb";
import { toast } from 'react-toastify';

const DragAndDrop = (props) => {
    const maxFiles = 1;
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (acceptedFiles.length > 1) {
                alert(`Please upload only ${maxFiles} file.`);
                return;
            }
            props.setSelectedFiles([...props.selectedFiles, ...acceptedFiles]);
        },
        // maxFiles: maxFiles,
    });

    return (
        <div className="drop-file-input" {...getRootProps()}>
            <input {...getInputProps()} />
            <div className="drop-file-input__label">
                <img src={uploadImg} alt="img" />
                {isDragActive ? (
                    <p>Drop the files here ...</p>
                ) : (
                    <p>Drag 'n' drop some files here, or click to select files</p>
                )}
            </div>

        </div>
    );
};


const WorkFlowInputStep = () => {
    const [selectedFiles, setSelectedFiles] = React.useState([]);
    const fileRemove = (file) => {
        const updatedList = [...selectedFiles];
        updatedList.splice(selectedFiles.indexOf(file), 1);
        setSelectedFiles(updatedList);
    };

    const UploadFileAPI_ = async (file) => {
        const data = new FormData();
        data.append('host', '74.80.190.17');
        data.append('username', 'sabhay');
        data.append('input_secret', 'abcdefgh567635@#%!&');
        data.append('file', file);
        try {
            const data11 = await toast.promise(
                fetch('https://workable-ai-ml-2.onrender.com/upload-file', {
                    method: 'POST',
                    body: data
                }).then(res => {
                    if (res.ok) {
                        return res.text();
                    } else {
                        throw new Error('Error in upload');
                    }
                })
                    .then(text => console.log(text))
                    .catch(err => console.log(err)),
                {
                    pending: 'Uploading File: ' + file.name,
                    success: 'Uploaded File: ' + file.name,
                    error: 'Error Uploading File' + file.name,
                }
            );
        } catch (error) {
            console.log(error);
        } finally {
            fileRemove(file)
        }
    }
    const UploadSelected = async () => {
        selectedFiles.map((file => {
            UploadFileAPI_(file);
        }))
    }

    return (
        <div className="input-step-body">
            <div className="input-step-box">
                <div className="drop-file-input"                >
                    <DragAndDrop selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} />
                </div>
                {selectedFiles.length > 0 ? (
                    <div className="drop-file-preview">
                        <p className="drop-file-preview__title">Ready to upload</p>
                        {selectedFiles.map((item, index) => (
                            <div key={index} className="drop-file-preview__item">
                                <div className="drop-file-preview__item__info">
                                    <p>{item.name}</p>
                                    <p>{item.size}B</p>
                                </div>
                                <span
                                    className="drop-file-preview__item__del"
                                    onClick={(item) => fileRemove(item)}
                                >
                                    x
                                </span>
                            </div>
                        ))}
                        <button className="drop-file-preview__item custom-file-upload-button" onClick={() => { UploadSelected() }}>
                            <div className="custom-file-upload">
                                Upload Selected Files<TbFileUpload className="upload-icons-sizes" />
                            </div>
                        </button>
                    </div>
                ) : null}
            </div>

        </div>
    )
}

export default WorkFlowInputStep;